<template>
  <div>
    <h3>{{ $t(electionLocations.pollType) }}</h3>
    <p v-html="$t(electionLocations.pollType + '_note')"></p>
    <election-location-list :electionLocations="electionLocations"></election-location-list>
    <hr />
  </div>
</template>

<script>
//import { nextTick } from 'vue'
import ElectionLocationList from './ElectionLocationList.vue'

export default {
  components: { ElectionLocationList },
  props: ['electionLocations', 'index'],
}
</script>
